/* eslint-disable complexity */
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { getAbweichung } from './getAbweichung';

export function AbweichungIcon({
  baseValue = 0,
  comparisonValue,
  tooltipMessage,
}: {
  baseValue?: number;
  comparisonValue: number;
  tooltipMessage?: string;
}) {
  const { prozentualeAbweichung, isNegative } = getAbweichung({
    baseValue,
    comparisonValue,
  });

  const color =
    prozentualeAbweichung <= 5
      ? 'text-primary-green-500'
      : prozentualeAbweichung > 5 && prozentualeAbweichung <= 10
      ? 'text-primary-orange-500'
      : 'text-primary-red-500';

  return !tooltipMessage || tooltipMessage.length < 1 ? (
    <FontAwesomeIcon
      icon={
        prozentualeAbweichung === 0 && prozentualeAbweichung <= 5
          ? faCheck
          : isNegative
          ? faCaretDown
          : faCaretUp
      }
      className={color}
    />
  ) : (
    <TooltipProvider>
      <Tooltip>
        <TooltipContent>{tooltipMessage}</TooltipContent>
        <TooltipTrigger>
          <FontAwesomeIcon
            icon={
              prozentualeAbweichung === 0 && prozentualeAbweichung <= 5
                ? faCheck
                : isNegative
                ? faCaretDown
                : faCaretUp
            }
            className={color}
          />
        </TooltipTrigger>
      </Tooltip>
    </TooltipProvider>
  );
}
